var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.7 7L.5 2.8C-.1 2.2-.1 1.1.5.5s1.7-.6 2.3 0L7 4.7 11.2.5c.6-.6 1.7-.6 2.3 0 .6.6.6 1.7 0 2.3L9.3 7l4.2 4.2c.6.6.6 1.7 0 2.3-.6.6-1.7.6-2.3 0L7 9.3l-4.2 4.2c-.6.6-1.7.6-2.3 0-.6-.6-.6-1.7 0-2.3L4.7 7z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.7b7fb360.svg";
export { ForwardRef as ReactComponent };